import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { jwtDecode } from 'jwt-decode';
import { firstValueFrom } from 'rxjs';
import { User } from '../../team-apis/otterdam/user';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserResolverService implements Resolve<User> {
  constructor(private authService: AuthService) {}

  async resolve(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Promise<User> {
    const user = await firstValueFrom(this.authService.user$);

    const accessToken = await firstValueFrom(
      this.authService.getAccessTokenSilently(),
    );
    const decodedToken = jwtDecode<{
      'https://accounts.sama.com/hubUserId': number;
      'https://accounts.sama.com/teamId': number;
      'https://accounts.sama.com/clientId': number;
    }>(accessToken);

    return {
      id: decodedToken['https://accounts.sama.com/hubUserId'],
      full_name: user?.name ?? '',
      email: user?.email ?? '',
      teamId: decodedToken['https://accounts.sama.com/teamId'],
      clientId: decodedToken['https://accounts.sama.com/clientId'],
    };
  }
}
